<template>
  <ais-instant-search
    :search-client="searchClient"
    :index-name="productsIndex"
    :middlewares="middlewares"
  >
    <ais-configure
      :facetFilters="facetFilters.productsIndex"
      :restrictSearchableAttributes="searchableAttributes.productsIndex"
    />
    <ais-index :index-name="promoCardsIndex">
      <ais-configure
        :restrictSearchableAttributes="searchableAttributes.promoCardsIndex"
        :facetFilters="[]"
      />
    </ais-index>
    <SearchFields />
  </ais-instant-search>
</template>

<script>
import algoliasearch from 'algoliasearch'
import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares'
import { AisInstantSearch, AisConfigure, AisIndex } from 'vue-instantsearch'
import insightsClient from 'search-insights'
import { getCookie } from '@/helpers/cookies'
import SearchFields from './SearchFields.vue'

const insightsMiddleware = createInsightsMiddleware({ insightsClient })

const uuid = getCookie('on_uuid')
insightsClient('setUserToken', uuid)

const algoliaAppId = 'ML35QLWPOC'
const algoliaKey = 'bff229776989d153121333c90db826b1'
const algoliaClient = algoliasearch(algoliaAppId, algoliaKey)

export const productsIndex = `${process.env.TARGET_ENV}_products_v2`
export const promoCardsIndex = `${process.env.TARGET_ENV}_promo_cards`

export default {
  name: 'Search',
  components: {
    SearchFields,
    AisInstantSearch,
    AisConfigure,
    AisIndex,
  },

  data() {
    return {
      middlewares: [insightsMiddleware],
      searchClient: {
        ...algoliaClient,
        search(requests) {
          // Algolia by default will query the index as soon as the instance is created.
          // In our case, we only want to query the index when the user types a search
          // https://www.algolia.com/doc/guides/building-search-ui/going-further/conditional-requests/vue/
          // https://github.com/algolia/doc-code-samples/blob/master/Vue%20InstantSearch/conditional-request/src/App.vue#L60-L70
          if (requests.every(({ params }) => !params.query)) {
            return Promise.resolve({
              results: requests.map(() => ({
                hits: [],
                nbHits: 0,
                processingTimeMS: 0,
              })),
            })
          }
          return algoliaClient.search(requests)
        },
      },
      productsIndex,
      promoCardsIndex,
    }
  },

  computed: {
    facetFilters() {
      const { country } = this.$store.state.page
      return {
        productsIndex: [[`stores_information.${country}.availability:true`]],
      }
    },

    searchableAttributes() {
      const { language } = this.$store.state.page
      return {
        productsIndex: [
          'product_name',
          'color',
          'gender',
          'product_type',
          `translated_fields.${language}`,
        ],
        promoCardsIndex: ['productGroup', `translated_fields.${language}.keywords`],
      }
    },
  },
}
</script>
